/**
 * Gets a cookie value by name
 * @param cookieName - The name of the cookie to retrieve
 * @returns The cookie value or empty string if not found
 */
export function getCookie(cookieName: string): string {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for(let i = 0; i <cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
    }
    }
    return "";
}

/**
 * Sets a cookie with optional expiration days
 * @param cookieName - The name of the cookie
 * @param cookieValue - The value to store in the cookie
 * @param expirationDays - Optional number of days until expiration
 * @returns void
 */
export function setCookie(cookieName: string, cookieValue: string, expirationDays?: number): void {
    const date = new Date();
    if (expirationDays) {
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    }
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${cookieName}=${cookieValue};${expires};path=/`;
}